module.exports = "data:image/png;base64,R0lGODlhAQABAIABAKhmY////ywAAAAAAQABAAACAkQBADs="